import { useQuery } from '@tanstack/react-query';

import type { ScopeContract } from '../../../types/extranet-api.types';
import { getExtranetApi } from '../extranetApi';

interface ScopeContractsInput {
  entityIds?: string[];
}

interface ScopeContractsResponse {
  contracts: ScopeContract[];
}

export const useScopeContracts = (input: ScopeContractsInput) =>
  useQuery({
    queryKey: ['extranet', 'scope', 'contracts', input] as const,
    queryFn: () =>
      getExtranetApi().get<ScopeContractsInput, ScopeContractsResponse>('/v1/extranet/scope/contracts', input),
    staleTime: 5 * 60 * 1000,
  });
